export enum DB_TABLES {
    visits = 'visits',
    patients = 'patients',
    activeOrderUpdates = 'activeOrderUpdates',
    prescriptions = 'prescriptions',
    DB_TABLE_MISC = 'misc',
    DB_TABLE_D_FORMS = 'dForms',
    milestones = 'milestones',
    symptoms = 'gSymptomsV2',
    diagnosis = 'gDiagnosisV2',
    medications = 'gMedicationsV2',
    injections = 'gInjections',
    advices = 'gAdvices',
    prescriptionTemplates = 'gPTemplates',
    vitals = 'gVitals',
    labTests = 'gLabTests',
    examinations = 'gExaminations',
    followUp = 'gFollowUp',
    services = 'gServices',
    refer = 'gRefer',
    medFrequency = 'gMedFrequency',
    medSOA = 'gMedSOA',
    medTiming = 'gMedTiming',
    dyForm = 'gPadDyForm',
    labVitals = 'gLabVitals',
    gLTTemplates = 'gLTTemplates',
    gMedTemplates = 'gMedTemplates',
    gSymTemplates = 'gSymTemplates',
    gDiaTemplates = 'gDiaTemplates',
    gLabVitalsTemplates = 'gLabVitalsTemplates',
    gExaminationsTemplates = 'gExaminationsTemplates',
    inventory = 'inventory',
    inventoryV2 = 'inventoryV2',
    snackingQuestions = 'snackingQuestions',
    dentalExaminations = 'gDentalExaminations',
    dentalProcedures = 'gDentalProcedures',
    dentalPastProcedures = 'gDentalPastProcedures',
    procedures = 'gProcedures',
    medicalRecordsTags = 'gMedicalRecordsTags',
    gInjectionTemplates = 'gInjectionTemplates',
    treatmentServices = 'gTreatmentServices',
    treatmentPackages = 'gTreatmentPackages',
    doctors = 'doctors',
    todayAppointments = 'todayAppointments',
    roles = 'roles',
    gProceduresTemplates = 'gProceduresTemplates',
    doctorsInBiz = 'doctorsInBiz',
    appointments = 'appointments',
}

export const NON_GENIE_TABLES = [
    DB_TABLES.visits,
    DB_TABLES.patients,
    DB_TABLES.activeOrderUpdates,
    DB_TABLES.prescriptions,
    DB_TABLES.DB_TABLE_MISC,
    DB_TABLES.DB_TABLE_D_FORMS,
    DB_TABLES.milestones,
    DB_TABLES.doctorsInBiz,
];
